<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col w-full p-5 md:p-10">
          <div>
            <button
              @click="$router.go(-1)"
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
            >
              Back
            </button>
          </div>

          <div class="flex flex-col gap-5 mt-5">
            <div>
              <div
                class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10"
              >
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Assessment Title
                  </p>
                  <p class="text-sm font-bold text-blues line-clamp-3">
                    {{ feedback_list[0]?.quize?.name || "NA" }}
                  </p>
                </div>
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Feedback Count
                  </p>
                  <p class="text-sm font-bold text-blues">
                    {{ totalcount }}
                  </p>
                </div>
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Averge ratings
                  </p>
                  <div class="text-sm font-bold text-blues">
                    <div
                      class="flex gap-2 items-center flex-wrap justify-center"
                    >
                      <div class="flex justify-center gap-1">
                        <template v-for="i in 5" :key="i">
                          <svg
                            :class="[
                              'w-6 h-6 transition',
                              i <= (feedback_list[0]?.avg_rating || 0)
                                ? 'text-yellow-400'
                                : 'text-gray-300',
                            ]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                            />
                          </svg>
                        </template>
                      </div>
                      {{ feedback_list[0]?.avg_rating || 0 }} Out of 5
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="w-full bg-[#edf8ff] flex flex-col sm:flex-row justify-center gap-3 sm:gap-5 items-center px-4 py-2 lg:px-8 rounded-md text-center"
              v-if="response_message"
            >
              <h2 class="text-blues text-center">
                {{ response_message }}
              </h2>

              <router-link
                :to="{ name: 'DownloadHistory' }"
                class="text-blue-600 text-xs underline font-bold"
              >
                Download History
              </router-link>
            </div>
            <div class="mb-5">
              <p class="text-lg text-blues font-semibold">Feedback Details</p>
            </div>

            <div class="flex justify-end">
              <div
                class="flex flex-wrap md:flex-nowrap items-center gap-3 mt-2 md:mt-0"
              >
                <div class="w-full md:w-[160px]">
                  <select
                    ref="selectedRating"
                    v-model="selectedRating"
                    @change="getfeedback(1)"
                    class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    :class="{ 'text-yellow-500': selectedRating }"
                  >
                    <option disabled value="">Rating...</option>
                    <option v-for="i in 5" :key="i" :value="i" class="w-5 h-5">
                      {{ "⭐".repeat(i) + "☆".repeat(5 - i) }}
                    </option>
                  </select>
                </div>

                <div class="w-full md:w-auto">
                  <select
                    ref="selectFilter"
                    name="model_select"
                    id="model_select"
                    v-model="selected_filter"
                    @change="getfeedback(1)"
                    class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  >
                    <option value="" disabled selected>Select sorting</option>
                    <!-- <option value="text">A to Z</option>
                    <option value="-text">Z to A</option> -->
                    <option value="created_at">Newest First</option>
                    <option value="-created_at">Oldest First</option>
                  </select>
                </div>
                <div class="relative w-full max-w-64">
                  <form @submit.prevent="getfeedback(1)">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Search"
                      id="search"
                      v-model="searching"
                      @input="getfeedback(1)"
                      class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <button
                      v-if="searching"
                      @click="clearSearch"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </form>
                </div>
                <div class="flex items-center gap-2 shrink-0">
                  <button
                    @click="clearFilters"
                    class="px-5 py-1.5 bg-blues text-white hover:bg-blue-600 rounded-full text-sm font-semibold whitespace-nowrap"
                  >
                    Clear
                  </button>
                </div>
                <button
                  type="button"
                  class="px-5 py-1 rounded-2xl font-semibold text-sm flex items-center gap-2 whitespace-nowrap transition-all duration-200"
                  @click="fetchdownload()"
                  :disabled="feedback_list.length === 0"
                  :class="[
                    feedback_list.length > 0
                      ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white'
                      : 'bg-gray-300 cursor-not-allowed text-gray-500',
                  ]"
                >
                  <img src="@/assets/newd/download1.png" alt="" />
                  <p class="text-sm text-white">Download</p>
                </button>
              </div>
            </div>
            <div class="mt-5">
              <div
                class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
              >
                <table
                  class="min-w-[700px] w-full divide-y divide-gray-200 text-sm"
                >
                  <thead class="bg-gray-50 text-blues">
                    <tr>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 whitespace-nowrap"
                      >
                        S NO
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Name
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Email
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Text
                      </th>
                      <th
                        class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                      >
                        Rating
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="feedback_list.length > 0">
                    <tr v-for="(el, index) in feedback_list" :key="el">
                      <td class="p-4 border-b text-center border-r">
                        <p class="text-primary">
                          {{ (current_page - 1) * 10 + index + 1 }}
                        </p>
                      </td>
                      <td
                        class="p-4 border-b text-center border-r whitespace-nowrap"
                      >
                        <p class="text-primary">
                          {{ el?.user_id?.display_name }}
                        </p>
                      </td>
                      <td
                        class="p-4 border-b text-center border-r whitespace-nowrap"
                      >
                        <p class="text-primary">{{ el?.user_id?.email }}</p>
                      </td>
                      <td
                        class="p-4 border-b text-center border-r lg:max-w-[400px]"
                      >
                        <p class="text-primary line-clamp-3">{{ el.text }}</p>
                        <!-- <p v-else>-</p> -->
                      </td>
                      <td class="p-4 border-b border-r text-center">
                        <div class="flex justify-center gap-1">
                          <template v-for="i in 5" :key="i">
                            <svg
                              :class="[
                                'w-6 h-6 transition',
                                i <= el.rating
                                  ? 'text-yellow-400'
                                  : 'text-gray-300',
                              ]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                              />
                            </svg>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="px-6 py-3 text-center">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <!-- PAGE SIZE -->
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getfeedback"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    SideBar,
    Pagination,
    FlashMessage,
  },
  data() {
    return {
      messages: { text: "", type: "null" },
      feedback_list: [],
      selected_filter: "",
      searching: "",
      selectedRating: "",
      pageSize: 10,
      current_page: 1,
      totalPages: 1,
      response_message: "",
      totalcount: 0,
    };
  },
  created() {
    this.getfeedback(1);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  props: ["course_id", "quiz_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    onPageSizeChange() {
      this.current_page = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.current_page = 1;
      }
      this.getfeedback(1);
    },
    async getfeedback(page = this.current_page) {
      this.current_page = page;
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/quiz-feedback/list/?course_id__in=${this.course_id}&quize_id__in=${this.quiz_id}&Key=${this.userInfo.token_key}&search=${this.searching}&page=${page}&page_size=${this.pageSize}&ordering=${this.selected_filter}&rating=${this.selectedRating}`,
        );

        if (res.data.data.status === 200) {
          this.feedback_list = res.data.data.data;
          this.totalPages = res.data.total_page;
          this.current_page = res.data.current_page;
          this.totalcount = res.data.total;
          this.average_rating = res.data.average_rating ?? 0;
        } else {
          this.feedback_list = [];
          this.totalPages = 1;
          this.totalcount = 0;
        }
      } catch (error) {
        console.error("Error fetching feedback:", error);
        this.feedback_list = [];
        this.totalcount = 0;
      }
    },
    clearFilters() {
      this.selected_filter = "";
      this.selectedRating = "";
      this.searching = "";
      this.getfeedback();
    },
    clearSearch() {
      this.searching = "";
      this.getfeedback(1);
    },
    async fetchdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/trigger-quiz-feedback-download/?course_id=${this.course_id}&quiz_id=${this.quiz_id}&Key=${this.userInfo.token_key}`,
        )
        // .then((resp) => {
        //   if (resp && resp.data.status == 200 && resp.data.download_link) {
        //     const link = document.createElement("a");
        //     link.href = resp.data.download_link;
        //     link.download = "";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //   }
        // })
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
